// WithRating.jsx
import { useMemo, useEffect } from 'react';
import PropTypes from 'prop-types';

import { NULL_FUNCTION } from '../resource/defaults.js';
import numberWithCommas from '../resource/numberWithCommas.js';

export const WithRating = ({
  id = null,
  ratingHighlightThreshold = 0,
  ratingStepSize = 0,
  rating = 0,
  ratingCount = 0,
  isDisplayRatingEnabled = false,
  canFetchMeRating = false,
  canFetchRatingSummary = false,
  children = NULL_FUNCTION,
  fetchMeRating = NULL_FUNCTION,
  fetchRatingSummary = NULL_FUNCTION,
}) => {
  const displayRating = useMemo(() => {
    if (!rating) return;
    if (ratingStepSize == null) return rating;
    return (rating / ratingStepSize).toFixed(1);
  }, [rating, ratingStepSize]);
  // fetch me rating
  useEffect(() => {
    if (canFetchMeRating) {
      fetchMeRating({ id });
    }
  }, [canFetchMeRating, fetchMeRating, id]);
  // fetch rating summary
  useEffect(() => {
    if (canFetchRatingSummary) {
      fetchRatingSummary({ id });
    }
  }, [canFetchRatingSummary, fetchRatingSummary, id]);
  return children({
    isDisplayRatingEnabled,
    rating,
    ratingCount,
    ratingStepSize,
    ratingHighlightThreshold,
    displayRating,
    displayRatingCount: numberWithCommas({ number: ratingCount }),
  });
};

WithRating.propTypes = {
  id: PropTypes.string,
  ratingHighlightThreshold: PropTypes.number,
  ratingStepSize: PropTypes.number,
  rating: PropTypes.number,
  ratingCount: PropTypes.number,
  isDisplayRatingEnabled: PropTypes.bool,
  canFetchMeRating: PropTypes.bool,
  canFetchRatingSummary: PropTypes.bool,
  children: PropTypes.func,
  fetchMeRating: PropTypes.func,
  fetchRatingSummary: PropTypes.func,
};

export default WithRating;
